export var LanguageConfigs = {
    CoopForbiddenLanguageCodes: ["xx"],
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/LanguageConfigs.ts
// module id = 1142
// module chunks = 3